export default __webpack_public_path__ + "static/media/full-giant.62c356f6.jpg";